import { render, staticRenderFns } from "./BounceRateChart.vue?vue&type=template&id=848a2d8a"
import script from "./BounceRateChart.vue?vue&type=script&lang=ts"
export * from "./BounceRateChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports